export default __webpack_public_path__ + "static/media/Celeste_CloudFront.8383e05f.png";